<!--用户预约课程-->
<template>

  <div class="root-container">

    <!--    查询结果区域-->
    <div class="search-result-area">

      <!--      表单结果-->
      <el-table
        :data="tableData"
        height="500"
        border
        style="width: 100%"
       >

        <el-table-column type="selection" width="55"></el-table-column>
        <!--<el-table-column prop="number" label="编号" width="100"></el-table-column>-->
        <el-table-column prop="date" label="时间" width="180"></el-table-column>
        <el-table-column prop="LogType" label="类型" width="180"></el-table-column>
        <el-table-column prop="userName" label="家长姓名"></el-table-column>
        <el-table-column prop="userPhone" label="手机号"></el-table-column>
        <el-table-column prop="cardName" label="卡名称"></el-table-column>
        <el-table-column prop="cardId"label="用户卡号"></el-table-column>
        <el-table-column prop="totalPay" label="支付金额"></el-table-column>
        <el-table-column prop="totalLesssonCount" label="总课时"></el-table-column>
        <el-table-column prop="remainingClass" label="剩余课时"></el-table-column>
        <el-table-column prop="cardEndTime" label="卡过期时间"></el-table-column>
      </el-table>

    </div>
  </div>
</template>

<style scoped>
  .root-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .search-result-area{
    width: 100%;
    margin-top: 50px;
    /*设置边框颜色和圆角*/
    border-top: 2px solid rgb(227,227,227);
    border-bottom: 1px solid rgb(227,227,227);
    border-left: 1px solid rgb(227,227,227);
    border-right: 1px solid rgb(227,227,227);
  }
</style>

<script>

  import timeUtils from "../../../utils/timeUtils";

  export default {
    name: 'UserBuyCardLog',
    props: {
      title: {
        msg: ''
      },
      detail :{
        type : Array,
        required:true,
      },
    },
    data() {
      return {
        tableData:[]
      }
    },
    created(){
      this.refreshData();
    },
    mounted() {

    },
    methods: {
      refreshData(){
        this.tableData = [];

        for (let i  = 0;i<this.detail.length;++i){
          let date = this.detail[i].time;
          let list = this.detail[i].content ;
          let LogType = this.detail[i].LogType;
          let data = {
            number:i+1,
            date:date,
            LogType:LogType,
            userName:list[0],
            userPhone:list[1],
            cardName:list[2],
            cardId:list[3],
            totalPay:list[4],
            totalLesssonCount:list[5],
            remainingClass:list[6],
            cardEndTime:list[7],
          }
          this.tableData.push(data);
        }

      }


    }
  }
</script>






// WEBPACK FOOTER //
// src/views/log/components/UserBuyCardLog.vue